import React, {useState} from 'react';
import styles from './UpdateAccount.module.scss';

import {useHistory} from 'react-router';
import {useCurrentUserContext} from '../../../context/CurrentUserProvider';
import {Page} from '../../../types';
import {useMusicKitContext} from '../../../context/MusicKitProvider';

export default function UpdateAccount() {
  const musicKit = useMusicKitContext();
  const [fullName, setfullName] = useState('');
  const [username, setUsername] = useState('');
  const currentUser = useCurrentUserContext();
  const history = useHistory();

  const updateAccount = async () => {
    await currentUser.update({
      username: username,
      fullName: fullName,
    });
    history.push(Page.Home);
  };

  const handleFullNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setfullName(event.target.value);
  };

  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(event.target.value);
  };

  const handleAppleMusicLogin = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    musicKit
      ?.authorize()
      .then((data: string) => {
        currentUser.updateToken(data);
      })
      .catch((error) => {
        // Handle something
      });
  };

  const updateAccountButtonDisabled = !fullName || !username;

  const musicKitLoginMarkup = (
    <button onClick={handleAppleMusicLogin}>Log in with Apple Music</button>
  );

  return (
    <div className={styles.UpdateAccount}>
      <form>
        <input
          value={fullName}
          onChange={handleFullNameChange}
          type="text"
          placeholder="Full name"
        />
        <input
          value={username}
          onChange={handleUsernameChange}
          type="text"
          placeholder="Username"
        />
      </form>
      <div>
        <button
          onClick={() => updateAccount()}
          disabled={updateAccountButtonDisabled}
        >
          Update
        </button>
      </div>
      <div>{musicKitLoginMarkup}</div>
    </div>
  );
}
